var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scouting-camera-image",class:_vm.containerClass},[_c('img',{staticClass:"remove-icon",attrs:{"src":require("@/assets/images/icons/close-red.svg")},on:{"click":_vm.remove}}),(_vm.data.image)?_c('img',{staticClass:"image-icon",attrs:{"src":_vm.data.image},on:{"click":_vm.show}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }